import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GroupsPage } from '@/features/admin/roles/GroupsPage';
import { directoryListSearchSchema } from '@/features/admin/roles/hooks/use-directory-pagination';

export const Route = createFileRoute('/_protected/t/$tenantId/admin/roles/groups')({
  component: GroupsPage,
  validateSearch: directoryListSearchSchema.extend({
    groupId: z.string().optional(),
  }),
});
